/**
 * BaseFretebas
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {BaseFretebasCollection} from '@/model/collection/BaseFretebasCollection'

/* TODO: review generated class */
export class BaseFretebas extends Resource {
  idFretebasPk: number = 0

  carga: string | null = null
  preco: string | null = null
  veiculos: string | null = null
  carroceria: string | null = null
  km: string | null = null
  especie: string | null = null
  complemento: string | null = null
  rastreamento: string | null = null
  obs: string | null = null
  nextel: string | null = null
  celular: string | null = null
  fone: string | null = null
  whatsup: string | null = null
  sac: string | null = null
  nome: string | null = null
  origem: string | null = null
  destino: string | null = null
  response: string | null = null

  get $id() {
    return this.idFretebasPk
  }
  set $id(val) {
    this.idFretebasPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of BaseFretebas
   */
  async getBaseFretebas(id: number) {
    return await Request.get(`/admin/base-fretebas/${id}`)
      .name('getBaseFretebas')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of BaseFretebas
   */
  static async listBaseFretebas(params: any) {
    return await Request.get(`/admin/base-fretebas`, {params})
      .name('listBaseFretebas')
      .as(BaseFretebasCollection)
      .getData()
  }

  /**
   * Persists a new instance of BaseFretebas. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistBaseFretebas() {
    return await Request.post(`/admin/base-fretebas`, this)
      .name('persistBaseFretebas')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of BaseFretebas to use it in a CSV file
   */
  static async listCsvBaseFretebas(params: any) {
    return await Request.get(`/admin/base-fretebas/csv`, {params})
      .name('listCsvBaseFretebas')
      .as(BaseFretebasCollection)
      .getData()
  }
}
